import React from 'react';
import ProductClassesHeader from 'components/product-classes/ProductClassesHeader';
import ProposalStatusLayout from 'components/common/proposal/ProposalStatusLayout';
import ProductClassesContent from 'components/product-classes/ProductClassesContent';
import { createStyles } from '../../globalStyles';

const ProductClassesPage = (): JSX.Element => {
  const classes = createStyles();

  return (
    <ProposalStatusLayout>
      <div className={classes.pageWrapper}>
        <ProductClassesHeader />
        <ProductClassesContent />
      </div>
    </ProposalStatusLayout>
  );
};

export default ProductClassesPage;
